import _ from 'lodash';
import dashboardService from '@/services/dashboardService';
import Dashboard from '../../model/dashboard';

const state = {
  baseUrl: '/dashboard',
  dashboardChart: [],
  dashboardData: {},
  loading: false,
  aSMReportLoading: false,
  aSMDashboardLoading: false,
  reportAILoading: false,
  dashboardAiReport: {},
  dashboardASMAiReport: [],
  dashboardASMAiDashboard: {}
};

const actions = {
  chartListFirst({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setDashboardChart', { dashboardChart: [] });

    dashboardService
      .list({ query })
      .then(response => {
        commit('setDashboardChart', { dashboardChart: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  mobileList({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setDashboardData', { dashboardData: {} });

    dashboardService
      .mobileList({ query })
      .then(response => {
        commit('setDashboardData', { dashboardData: response.data });
        commit('finishRequest');
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  aiReport({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDashboardAiReport', { dashboardAiReport: {} });
    commit('startReportRequest');
    dashboardService
      .aiReport({ query })
      .then(response => {
        commit('setDashboardAiReport', { dashboardAiReport: response.data });
        commit('finishRequest');
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  aiASMReport({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDashboardASMAiReport', { dashboardASMAiReport: {} });
    commit('startASMReportRequest');
    dashboardService
      .aiASMReport({ query })
      .then(response => {
        commit('setDashboardASMAiReport', { dashboardASMAiReport: response.data });
        commit('finishRequest');
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  aiASMDashboard({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDashboardASMAiDashboard', { dashboardASMAiDashboard: {} });
    commit('startASMDashboardRequest');
    dashboardService
      .aiASMDashboard({ query })
      .then(response => {
        commit('setDashboardASMAiDashboard', { dashboardASMAiDashboard: response.data });
        commit('finishRequest');
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  startReportRequest(state) {
    state.reportAILoading = true;
  },
  startASMReportRequest(state) {
    state.aSMReportLoading = true;
  },
  startASMDashboardRequest(state) {
    state.aSMDashboardLoading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  finishRequest(state) {
    state.loading = false;
  },
  setDashboardChart(state, { dashboardChart }) {
    let row = 1;
    state.dashboardChart = _.map(dashboardChart, dashboard => {
      const newDashboard = new Dashboard({
        row,
        storeid: dashboard.storeid,
        storename: dashboard.storename,
        cluster: dashboard.cluster,
        region: dashboard.region,
        count: dashboard.count,
        submittedCount: dashboard.submittedCount,
        pendingCount: dashboard.pendingCount
      });
      row += 1;
      return newDashboard;
    });
  },
  setDashboardData(state, { dashboardData }) {
    state.dashboardData = dashboardData;
  },
  setDashboardAiReport(state, { dashboardAiReport }) {
    state.dashboardAiReport = dashboardAiReport;
    state.reportAILoading = false;
  },
  setDashboardASMAiReport(state, { dashboardASMAiReport }) {
    state.dashboardASMAiReport = dashboardASMAiReport;
    state.aSMReportLoading = false;
  },
  setDashboardASMAiDashboard(state, { dashboardASMAiDashboard }) {
    state.dashboardASMAiDashboard = dashboardASMAiDashboard;
    // state.dashboardASMAiDashboard = {
    //   correct: 2734,
    //   incorrect: 1091,
    //   total: 3825,
    //   all: [
    //     {
    //       'Sagar SenGupta': {
    //         correct: 858,
    //         incorrect: 312,
    //         total: 1170,
    //         stores: {
    //           AVISHAR: {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           },
    //           'TOLLY CLUB': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Meena icon': {
    //             correct: 36,
    //             incorrect: 9,
    //             total: 45
    //           },
    //           'KOL Sodepur Daily': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           },
    //           'Serampore Super': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           'Ray Nagar': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'SUCASA NARENDRAPUR': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'RAMRAJATALA DAILY': {
    //             correct: 40,
    //             incorrect: 5,
    //             total: 45
    //           },
    //           'B T Road D': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           SPRINGDALE: {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'AUROBINDO MALL': {
    //             correct: 27,
    //             incorrect: 18,
    //             total: 45
    //           },
    //           Azadgarh: {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'TOLLY HEIGHTS': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'Maheshtala Super': {
    //             correct: 39,
    //             incorrect: 6,
    //             total: 45
    //           },
    //           Gariahat: {
    //             correct: 40,
    //             incorrect: 5,
    //             total: 45
    //           },
    //           'Club Town Heights': {
    //             correct: 27,
    //             incorrect: 18,
    //             total: 45
    //           },
    //           'KOL Hazra Super': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           'Madhyamgram Hyper': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           'KONNAGAR DAILY': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           Haldia: {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           },
    //           'BELUR HYPER': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Barasat Super': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'KOL Madhyamgram Daily': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           Acropolis: {
    //             correct: 36,
    //             incorrect: 9,
    //             total: 45
    //           },
    //           'Barrackpore Super': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Alipore Daily': {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Awadhesh Yadav': {
    //         correct: 467,
    //         incorrect: 208,
    //         total: 675,
    //         stores: {
    //           Upohar: {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           },
    //           'KOL Mukundapur D': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           MAHAMAYATALA: {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           PATULI: {
    //             correct: 25,
    //             incorrect: 20,
    //             total: 45
    //           },
    //           'Lake Town Daily': {
    //             correct: 38,
    //             incorrect: 7,
    //             total: 45
    //           },
    //           Downtown: {
    //             correct: 39,
    //             incorrect: 6,
    //             total: 45
    //           },
    //           'Garia D': {
    //             correct: 23,
    //             incorrect: 22,
    //             total: 45
    //           },
    //           'AMP Vaisaakkhii': {
    //             correct: 27,
    //             incorrect: 18,
    //             total: 45
    //           },
    //           'DLF SUPER': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Lake Town Super': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           Rashbehari: {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           'NEW TOWN SQUARE': {
    //             correct: 36,
    //             incorrect: 9,
    //             total: 45
    //           },
    //           Liluah: {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           Manisquare: {
    //             correct: 30,
    //             incorrect: 15,
    //             total: 45
    //           },
    //           'AQUA PURTI': {
    //             correct: 16,
    //             incorrect: 14,
    //             total: 30
    //           },
    //           'SIDDHA TOWN': {
    //             correct: 8,
    //             incorrect: 7,
    //             total: 15
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Mukendra Singh': {
    //         correct: 429,
    //         incorrect: 201,
    //         total: 630,
    //         stores: {
    //           'Varanasi Bhelupur Super': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           Taramandal: {
    //             correct: 21,
    //             incorrect: 24,
    //             total: 45
    //           },
    //           'Varanasi Sigra Super': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           Bhojubeer: {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Gorakhpur Hyper': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Senpura Super': {
    //             correct: 23,
    //             incorrect: 22,
    //             total: 45
    //           },
    //           'VARANASI PAHARIYA': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Alkapuri Hyper': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'Super_Allahabad Super_EAST UP': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           'Padari Bazar': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           BHADOHI: {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           },
    //           'AD MALL': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           },
    //           'PDR Mall': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Varanasi Mahmoorganj': {
    //             correct: 23,
    //             incorrect: 22,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Sudipto Chowdhury': {
    //         correct: 298,
    //         incorrect: 107,
    //         total: 405,
    //         stores: {
    //           Kharagpur: {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Vega Mall Siliguri Super': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           },
    //           'Durgapur Hyper': {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           },
    //           'Biddhanagar Daily': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'SILIGURI BURDWAN ROAD': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Asansol Daily': {
    //             correct: 38,
    //             incorrect: 7,
    //             total: 45
    //           },
    //           'DGP Benachity Super': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'Siliguri Hyper': {
    //             correct: 28,
    //             incorrect: 17,
    //             total: 45
    //           },
    //           ' SEVOKE ROAD-SILIGURI': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'VISHAL SINGH ': {
    //         correct: 573,
    //         incorrect: 237,
    //         total: 810,
    //         stores: {
    //           Super_Vrindavan_EUP: {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Daily_LKO Aliganj Odhani D_EAST UP': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           },
    //           'Metro Crystal Square': {
    //             correct: 40,
    //             incorrect: 5,
    //             total: 45
    //           },
    //           'Daily_LKO Indira Nagar Sec12 D_EAST UP': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Daily_LKO Vrindavan Colony D_EAST UP': {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           },
    //           'Daily_LKO Rajajipuram D_EAST UP': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Daily_LKO Aliganj Chandralok D_EAST UP': {
    //             correct: 31,
    //             incorrect: 14,
    //             total: 45
    //           },
    //           'Daily_LKO Ashiana D_EAST UP': {
    //             correct: 32,
    //             incorrect: 13,
    //             total: 45
    //           },
    //           'Daily_Vikasnagar_LekhrajPanna_East UP': {
    //             correct: 22,
    //             incorrect: 23,
    //             total: 45
    //           },
    //           'Daily_LKO Vivek Khand D_EAST UP': {
    //             correct: 28,
    //             incorrect: 17,
    //             total: 45
    //           },
    //           'Daily_LKO Vikas Nagar D_EAST UP': {
    //             correct: 25,
    //             incorrect: 20,
    //             total: 45
    //           },
    //           'Lekhraj Hyper': {
    //             correct: 28,
    //             incorrect: 17,
    //             total: 45
    //           },
    //           'Daily_LKO Rajendra Nagar D_EAST UP': {
    //             correct: 34,
    //             incorrect: 11,
    //             total: 45
    //           },
    //           'Daily_LKO Eldeco D_EAST UP': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           },
    //           'Daily_LKO Janakipuram D_EAST UP': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           'BARABANKI SUPER': {
    //             correct: 39,
    //             incorrect: 6,
    //             total: 45
    //           },
    //           'FUN MALL LUCKNOW': {
    //             correct: 33,
    //             incorrect: 12,
    //             total: 45
    //           },
    //           'Crown Mall': {
    //             correct: 29,
    //             incorrect: 16,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Rohit Karmakar': {
    //         correct: 37,
    //         incorrect: 8,
    //         total: 45,
    //         stores: {
    //           'South City': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Biswanath Mukherjee': {
    //         correct: 35,
    //         incorrect: 10,
    //         total: 45,
    //         stores: {
    //           'Quest Hyper': {
    //             correct: 35,
    //             incorrect: 10,
    //             total: 45
    //           }
    //         }
    //       }
    //     },
    //     {
    //       'Md. Noor Asif': {
    //         correct: 37,
    //         incorrect: 8,
    //         total: 45,
    //         stores: {
    //           'AXIS HYPER': {
    //             correct: 37,
    //             incorrect: 8,
    //             total: 45
    //           }
    //         }
    //       }
    //     }
    //   ],
    //   byDate: [
    //     {
    //       1: {
    //         correct: 908,
    //         incorrect: 352,
    //         total: 1260
    //       }
    //     },
    //     {
    //       2: {
    //         correct: 914,
    //         incorrect: 376,
    //         total: 1290
    //       }
    //     },
    //     {
    //       3: {
    //         correct: 912,
    //         incorrect: 363,
    //         total: 1275
    //       }
    //     }
    //   ],
    //   checklistsByRegion: {
    //     'STORE OPENING_CHECKLIST': {
    //       'Sagar SenGupta': {
    //         correct: 858,
    //         incorrect: 312,
    //         total: 1170
    //       },
    //       'Awadhesh Yadav': {
    //         correct: 467,
    //         incorrect: 208,
    //         total: 675
    //       },
    //       'Mukendra Singh': {
    //         correct: 429,
    //         incorrect: 201,
    //         total: 630
    //       },
    //       'Sudipto Chowdhury': {
    //         correct: 298,
    //         incorrect: 107,
    //         total: 405
    //       },
    //       'VISHAL SINGH ': {
    //         correct: 573,
    //         incorrect: 237,
    //         total: 810
    //       },
    //       'Rohit Karmakar': {
    //         correct: 37,
    //         incorrect: 8,
    //         total: 45
    //       },
    //       'Biswanath Mukherjee': {
    //         correct: 35,
    //         incorrect: 10,
    //         total: 45
    //       },
    //       'Md. Noor Asif': {
    //         correct: 37,
    //         incorrect: 8,
    //         total: 45
    //       }
    //     }
    //   }
    // };
    state.aSMDashboardLoading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
